import {customAxios} from '@infrastructure/api/CustomAxios';
import {Endpoints} from '@config/Endpoints';

export const SignatureResource = {
  uploadSignature: (formData: FormData) => {
    return customAxios.post(Endpoints.profile.uploadSignature, formData);
  },
};
